import HomePage from 'components/pages/Home';

import { toAbsoluteLink } from 'lib/links';
import { resolvify } from 'lib/promises';

import { getAds } from 'services/ads';
import { getCategoriesList } from 'services/category';
import { getLandingsList } from 'services/landing';
import { getFeaturedOffersList, getRecentOffersList } from 'services/offer';
import { getStoresList } from 'services/store';

import APP from 'constants/app';
import LINKS from 'constants/links';

const CANONICAL_URL = toAbsoluteLink(LINKS.RECENT_OFFERS);
const DESCRIPTION =
  'Os achados do dia no Promobit: as melhores promoções da internet em ordem cronológica, atualizadas em tempo real pela comunidade.';
const OFFERS_SERVER_LIMIT = 12;
const PAGE_H1 = 'Achados do Dia';
const PAGE_TITLE =
  'Achados do Dia: As Melhores Promoções da Internet | Promobit';
const TAB_NAME = 'recents';

const Recents = ({
  cardsAds,
  landscapeAds,
  recoveryPassword,
  serverFeaturedOffers,
  serverOffers,
  smallAds,
}) => (
  <HomePage
    canonicalUrl={CANONICAL_URL}
    cardsAds={cardsAds}
    description={DESCRIPTION}
    h1Text={PAGE_H1}
    landscapeAds={landscapeAds}
    pageTitle={PAGE_TITLE}
    recoveryPassword={recoveryPassword}
    serverFeaturedOffers={serverFeaturedOffers}
    serverOffers={serverOffers}
    smallAds={smallAds}
  />
);

export const getServerSideProps = async ({ query }) => {
  try {
    const [
      serverOffers,
      serverFeaturedOffers,
      categories,
      stores,
      featuredLandings,
      highlightedLandings,
      {
        data: {
          cardAd: cardsAds = [],
          homeAd: landscapeAds = [],
          smallAd: smallAds = [],
          topAd: [topbarAd = null],
          topbarHighlight: navbarAds,
        },
      },
    ] = await resolvify([
      getRecentOffersList({ limit: OFFERS_SERVER_LIMIT, ...query }),
      { fn: getFeaturedOffersList(), fallback: getFeaturedOffersList.fallback },
      {
        fn: getCategoriesList({ selectedCategories: true }),
        fallback: getCategoriesList.fallback,
      },
      {
        fn: getStoresList({ from: 'topbar' }),
        fallback: getStoresList.fallback,
      },
      {
        fn: getLandingsList({ featured: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getLandingsList({ highlighted: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getAds(),
        fallback: getAds.fallback,
      },
    ]);

    return {
      props: {
        cardsAds,
        landscapeAds,
        serverFeaturedOffers,
        serverOffers,
        smallAds,
        [APP.CTX_OPTIONAL_PROPS]: {
          activeOffersListTab: TAB_NAME,
          categories,
          featuredLandings,
          highlightedLandings,
          navbarAds,
          stores,
          topbarAd,
        },
      },
    };
  } catch {
    return { redirect: { destination: LINKS[500], permanent: false } };
  }
};

export default Recents;
